import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './GamificationBadge.module.css';

import academicAce from './images/AcademicAce.png';
import clientChampion from './images/ClientChampion.png';
import mediaMaven from './images/MediaMaven.png';
import perfectPortfolio from './images/PerfectPortfolio.png';
import profilePro from './images/ProfilePro.png';
import statSheetSuperstar from './images/StatSheetSuperstar.png';
import topTalent from './images/TopTalent.png';
import verifiedVet from './images/VerifiedVet.png';
import {withViewport} from "../../util/uiHelpers";

const MODAL_BREAKPOINT = 1023;


const GamificationBadge = props => {
  const { className, rootClassName, badgeName, itemClassName, titleClassName, viewport, } = props;


  if(!badgeName || badgeName === 'undefined') return null;

  const [showTitle, setShowTitle] = useState(false);

  const isMobileLayout = viewport.width <= MODAL_BREAKPOINT;


  const handleClick = (e) => {
    e.preventDefault();

    setShowTitle(!showTitle);
  }


  const classes = classNames(rootClassName || css.root, className);

  const imageData = [];


  badgeName?.map(badge => {
    if(badge === 'AcademicAce') {
      imageData.push({
        imageSrc: academicAce,
        title: 'Athletes who have a 3.5 GPA for three consecutive academic quarters'
      })
    }
    else if(badge === 'ClientChampion') {
      imageData.push({
        imageSrc: clientChampion,
        title: 'Awarded after completing 25 sessions with different athletes'
      })
    }
    else if(badge === 'MediaMaven') {
      imageData.push({
        imageSrc: mediaMaven,
        title: 'Awarded after 5 sessions with 5 different creators'
      })
    }
    else if(badge === 'PerfectPortfolio') {
      imageData.push({
        imageSrc: perfectPortfolio,
        title: 'Earned when a creator received five 5-star ratings in a row'
      })
    }
    else if(badge === 'ProfilePro') {
      imageData.push({
        imageSrc: profilePro,
        title: 'Completing 100% of profile fields (GPA, schedule, highlight reels, etc)'
      })
    }
    else if(badge === 'StatSheetSuperstar') {
      imageData.push({
        imageSrc: statSheetSuperstar,
        title: 'When an athlete adds 10 games worth of statistics'
      })
    }
    else if(badge === 'TopTalent') {
      imageData.push({
        imageSrc: topTalent,
        title: 'Creators who maintain a 4.8+ rating after serving 20 clients'
      })
    }
    else if(badge === 'VerifiedVeteran') {
      imageData.push({
        imageSrc: verifiedVet,
        title: 'Given after being on the platform for a month during beta'
      })
    }
  });


  const items = imageData.map((d, index) => {
    return (
      <li key={index} onClick={(e) => handleClick(e)} className={classNames(css.item, itemClassName, showTitle && css.showTitle)}>
        <img className={css.image} src={d.imageSrc} alt={d.title} />
        <span className={classNames(css.imgTitle, titleClassName)}>{d.title}</span>
      </li>
    );
  });



  return <ul className={classes}>
    {items}
  </ul>;
};

const { number, string } = PropTypes;

GamificationBadge.defaultProps = {
  className: null,
  rootClassName: null,
};

GamificationBadge.propTypes = {
  className: string,
  rootClassName: string,
};

export default withViewport(GamificationBadge);
